var map = {
	"./Union.svg": 507,
	"./arrow-down-v2.svg": 508,
	"./arrow-right-v2.svg": 509,
	"./arrows/arrow-dropdown.svg": 510,
	"./arrows/arrow-left.svg": 511,
	"./arrows/arrow-right.svg": 512,
	"./arrows/arrow_left.svg": 513,
	"./arrows/arrow_right.svg": 514,
	"./arrows/next.svg": 515,
	"./arrows/prev.svg": 516,
	"./categories/animation.svg": 517,
	"./categories/archeology.svg": 518,
	"./categories/business-development.svg": 519,
	"./categories/communication-journalism.svg": 520,
	"./categories/construction-rehabilitation.svg": 521,
	"./categories/education.svg": 522,
	"./categories/environment-ecovolunteering.svg": 523,
	"./categories/health.svg": 524,
	"./categories/law.svg": 525,
	"./categories/social-integration.svg": 526,
	"./categories/tourism.svg": 527,
	"./categories/urgency.svg": 528,
	"./check.svg": 529,
	"./close.svg": 530,
	"./edit.svg": 531,
	"./email.svg": 532,
	"./facebook-v2.svg": 533,
	"./facebook.svg": 534,
	"./heart.svg": 535,
	"./hearts/heart-empty.svg": 536,
	"./hearts/heart-full.svg": 537,
	"./icon_accept.svg": 538,
	"./icon_delete.svg": 539,
	"./icon_help.svg": 540,
	"./icon_instagram.svg": 541,
	"./icon_linkedin.svg": 542,
	"./icon_messenger.svg": 543,
	"./icon_play.svg": 544,
	"./icon_sad.svg": 545,
	"./icon_search.svg": 546,
	"./icon_send-message-disabled.svg": 547,
	"./icon_send-message.svg": 548,
	"./icon_watch.svg": 549,
	"./instagram.svg": 550,
	"./linkedin.svg": 551,
	"./plus-unsafe.svg": 552,
	"./remove-icon.svg": 553,
	"./share.svg": 554,
	"./show.svg": 555,
	"./stars/star-empty.svg": 556,
	"./stars/star-full.svg": 557,
	"./twitter.svg": 558,
	"./user-dropdown/account.svg": 559,
	"./user-dropdown/balance.svg": 560,
	"./user-dropdown/help-center.svg": 561,
	"./user-dropdown/missions.svg": 562,
	"./user-dropdown/personal-info.svg": 563,
	"./user-dropdown/profile.svg": 564,
	"./user-dropdown/refunds.svg": 565,
	"./user-dropdown/revenues.svg": 566,
	"./user-dropdown/settings.svg": 567,
	"./user-dropdown/sign-out.svg": 568,
	"./user-dropdown/structure.svg": 569,
	"./user-dropdown/volunteers.svg": 570,
	"./verification/in_progress.svg": 571,
	"./verification/unverified.svg": 572,
	"./verification/verified.svg": 573,
	"./website.svg": 574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 506;